import React from 'react';
import QueryBuilder from '../QueryBuilder/QueryBuilder';

const FilterConditions = ({
  variantInfo = null,
  typoIndex,
  variantIndex,
  setVariantRenderData,
  isReadOnly,
  onDirtyField
}) => {
  return (
    <div>
      <QueryBuilder
        type={`condition`}
        typoIndex={typoIndex}
        variantIndex={variantIndex}
        variantInfo={variantInfo}
        isReadOnly={isReadOnly}
        allowNewIfEmpty={true}
        queryValue={variantInfo.condition}
        setVariantRenderData={setVariantRenderData}
        onDirtyField={onDirtyField}
      />
    </div>
  );
};

export default FilterConditions;
